module.exports = "https://coursera_assets.s3.amazonaws.com/images/423be7e6725852b0177185f6e025ba5a.png";